import type { SkiAreaSlopes } from '@/cms/fields/mappers/destinationPageFieldsMapper'
import { useIntl } from '@/intl'
import { InfoCard } from '../InfoCard/InfoCard'
import { ProgressBar, type Segment, type SegmentVariant } from '../ProgressBar/ProgressBar'

const SLOPE_VARIANTS: SegmentVariant[] = ['black', 'red', 'blue', 'green']

interface SlopesProps {
  data: SkiAreaSlopes
}

export function Slopes({ data }: SlopesProps) {
  const intl = useIntl()

  const useCountMode = !data.totalKm
  const field = useCountMode ? 'count' : 'km'
  const suffix = useCountMode ? '' : 'km'

  const segments: Segment[] = SLOPE_VARIANTS.map(variant => ({
    variant,
    value: data[variant][field],
    valueSuffix: suffix,
    count: data[variant].count,
    label: intl.formatMessage({ id: `destination_ski_area_slopes_${variant}` }),
  }))

  const total = useCountMode
    ? SLOPE_VARIANTS.reduce((sum, variant) => sum + data[variant].count, 0)
    : data.totalKm
  const tag = intl.formatMessage(
    { id: useCountMode ? 'destination_ski_area_total_count' : 'destination_ski_area_total_km' },
    { value: total },
  )

  const slopesTitle = intl.formatMessage({ id: 'destination_ski_area_slopes_title' })
  const title = useCountMode
    ? `${slopesTitle} (${intl.formatMessage({ id: 'destination_ski_area_slopes_count_suffix' })})`
    : slopesTitle

  return (
    <InfoCard
      title={title}
      titleId="ski-area-slopes-title"
      icon="MountainsSlope"
      tag={tag}
    >
      <ProgressBar
        segments={segments}
        max={total}
        title={title}
      />
    </InfoCard>
  )
}
